export class Video {
    constructor(public id: number, public displayOrder: number, public title: string, public url: string) {}
}
